import { useEffect, useState } from "react";

import { ServiceError, SpinnerCenter } from "@shapr3d/frontend-lib";
import { useLocation } from "react-router-dom";

import ZendeskEmailVerify from "../components/ZendeskEmailVerify/ZendeskEmailVerify";
import ZendeskLogOut from "../components/ZendeskLogOut/ZendeskLogOut";
import useNavigation from "../hooks/navigation";
import { useLogout, useResendVerificationEmail, useZendeskToken } from "../hooks/useAuth";
import { SearchParam, ServiceErrorCode } from "../types";

enum ZendeskError {
  None,
  EmailVerification,
  Unknown,
}

const SignInZendeskContainer = () => {
  const [zendeskError, setZendeskError] = useState(ZendeskError.None);
  const location = useLocation();
  const navigation = useNavigation();

  const { mutateAsync: mutateLogout } = useLogout();

  const { mutateAsync: mutateResendVerificationEmail } = useResendVerificationEmail();
  const {
    data: zendeskTokenData,
    isFetching: isZendeskTokenFetching,
    error: zendeskTokenError,
  } = useZendeskToken();

  useEffect(() => {
    if (zendeskTokenData?.zendeskToken) {
      const urlQuery = new URLSearchParams(location.search);
      navigation.goToZendesk(
        zendeskTokenData.zendeskToken,
        urlQuery.get(SearchParam.ReturnTo) ?? ""
      );
    }
  }, [zendeskTokenData, navigation, location]);

  useEffect(() => {
    if (!zendeskTokenError) {
      return;
    }

    if (zendeskTokenError instanceof ServiceError) {
      if (zendeskTokenError.hasCode(ServiceErrorCode.EmailNotVerified)) {
        setZendeskError(ZendeskError.EmailVerification);
      } else {
        setZendeskError(ZendeskError.Unknown);
      }
    } else {
      mutateLogout();
    }
  }, [zendeskTokenError, mutateLogout]);

  return (
    <>
      {isZendeskTokenFetching && <SpinnerCenter />}
      {zendeskError === ZendeskError.EmailVerification && (
        <ZendeskEmailVerify onResendClick={mutateResendVerificationEmail} />
      )}
      {zendeskError === ZendeskError.Unknown && (
        <ZendeskLogOut errorMessage="Unknown error happened." />
      )}
    </>
  );
};

export default SignInZendeskContainer;
